<template>
  <div v-if="isLoading" class="app-loading-overlay">
    <div class="app-loading-content">
      <v-icon icon="sync" size="48px" color="primary" class="mb-4 animate-spin" />
      <h3 class="text-lg font-medium mb-2">{{ loadingMessage }}</h3>
      <p class="text-sm text-secondary">{{ loadingSubMessage }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useAuthStore } from '../stores/auth-store'

const authStore = useAuthStore()

// Show full-screen loading only for auth bootstrap.
// Shop details can refresh in the background; don't block the whole UI for that.
const isLoading = computed(() => {
  if (authStore.isLoading) {
    return true
  }
  return false
})
const loadingMessage = computed(() => {
  if (authStore.isLoading) {
    return 'Loading your dashboard...'
  }
  return 'Loading...'
})
const loadingSubMessage = computed(() => {
  if (authStore.isLoading) {
    return 'Please wait while we fetch your data'
  }
  return 'Please wait'
})
</script>

<style scoped>
.app-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.app-loading-content {
  text-align: center;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 90%;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .app-loading-overlay {
    background: rgba(0, 0, 0, 0.95);
  }

  .app-loading-content {
    background: #1a1a1a;
    color: white;
  }
}
</style>
